























import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import AppPreloader from '@/components/App/AppPreloader.vue';
import { Environment } from '@/types';

interface Dictionary<T> {
  [Key: number]: T;
}

@Component({ components: { AppPreloader } })
export default class EditCutoverplanEnvironmentsTab extends Vue {
  @Prop()
  cutoverplan?: any;

  environmentsEnabledById: Dictionary<boolean> = {};

  refreshing = false;

  @Watch('environmentsEnabledById')
  environmentsChanged() {
    if (this.$store.state.all_environments.length < 1) return;
    this.cutoverplan.environments = [
      Object.keys(this.environmentsEnabledById)
        // @ts-ignore
        .filter((id: number): boolean => this.environmentsEnabledById[id])
        // @ts-ignore
        .map((id: number) => this.$store.state.all_environments?.find((env) => +env.id === +id))
    ];
  }

  toggleEnvironment(environment: Environment) {
    const enabled = this.environmentsEnabledById[environment.id];

    if (!enabled) {
      const index = this.cutoverplan.environments.indexOf(
        this.cutoverplan.environments?.find((env: Environment) => env.id === environment.id)
      );
      this.cutoverplan.environments.splice(index, 1);
    } else {
      this.cutoverplan.environments.push({
        environment_id: environment.id,
        cutoverplan_id: this.cutoverplan.id,
        environment
      });
    }
  }

  @Watch('cutoverplan.environments')
  async refresh() {
    this.refreshing = true;
    await this.$store.dispatch('refreshAllEnvironments');
    this.$store.state.all_environments.forEach((environment: any) => {
      this.environmentsEnabledById[environment.id] = !!this.cutoverplan.environments?.find(
        (envInCop: any) => envInCop.environment_id === environment.id
      );
    });
    this.refreshing = false;
  }

  mounted() {
    this.refresh();
  }
}
